import React, { useState, useEffect } from 'react'
import { useAppData } from '../../context/AppDataContext'
import { Dialog, DialogContent } from '@mui/material';
import CompanyForm from '../../app/admin/erp/finance/company/components/CompanyForm';
import { ArrowDropDown } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

function CompanySelector() {
  
    const {companyDD, getCompanyDD} = useAppData();
    const [dialogStatus, setDialogStatus] = useState(false);
    const [activeCompany,setActiveCompany] = useState(JSON.parse(localStorage.getItem("activeCompany")));
    const navigate = useNavigate();
    
    const updateSelectedCompany = (company) =>{
        setActiveCompany(company);
        localStorage.setItem("activeCompany",JSON.stringify(company))
        setDialogStatus(false);
        navigate("/");
        window.location.reload();
    }
    
    useEffect(()=>{
        if(!activeCompany){
            if(companyDD.length == 1){
                updateSelectedCompany(companyDD[0]);
            }
            setDialogStatus(true)
        }
    },[activeCompany])

    return (
    <>
        {activeCompany && <button className='btn btn-outline-primary' onClick={()=>setDialogStatus(true)}>{activeCompany.label}<ArrowDropDown/> </button>}
        <Dialog
            open={dialogStatus}
            keepMounted
            fullWidth={true}
            maxWidth="md"
        >
            <DialogContent>
                {companyDD.length === 0 &&
                    <div className="row"> 
                        <div className='col-md-12'>
                            <div className='alert alert-danger'>
                                No company found, Create a company to continue
                            </div>
                        </div>
                        <CompanyForm callBack={getCompanyDD} />
                     </div>
                }

                {companyDD.length > 0 &&
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='alert alert-primary'>
                                Select a company to Continue
                            </div>
                        </div>

                        <div className='col-md-12'>
                            {companyDD.map(company=>
                                <button className='btn btn-outline-primary' key={company.value} onClick={()=>updateSelectedCompany(company)} >{company.label}</button>
                            )}
                        </div>

                    </div>
                }

            </DialogContent>
        </Dialog>
    </>
  )
}

export default CompanySelector